import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";

import React, { useEffect, useState } from "react";
import { getStoreCustomerAccount } from "../../services/StoreCustomerAccount/getStoreCustomerAccount";
import { updateOrderPayment } from "../../services/OrderPayment/orderPayment";
import SuccessModal from "../SuccessModal";
import { getLocalPaymentMode, getStoreLocalData } from "../../utils/localStorage";
import { getViewPaymentMode, getViewPaymentModeV2 } from "../../services/paymentMode/paymentMode";

const CollectPaymentEdit = ({
  collectPaymentEditModalVisible,
  setCollectPaymentEditModalVisible,
  sendDataToCollectPaymentUpdateModal,
  storeId,
  storeCustomerId,
  selectedPaymentItemValue,
  bookingOrderId,
  balanceAmount,
  customerOrdersData,
  enableUserAccountDeliveryDiscount,
  storeUserId,
  userRole,
  enabledBackDate,
  brandId,
  enabledAmountRoundOff
}) => {
  // const displayDate =
  //   customerOrdersData?.status === "DELIVERED" ||
  //   customerOrdersData?.status === "DONE"
  //     ? customerOrdersData?.deliveredOn
  //     : customerOrdersData?.deliveryOn;

  const grandTotal = customerOrdersData.grandTotal;

  const displayDate = customerOrdersData?.createdDate;

  const { storeLocalData } = getStoreLocalData();

  const [receiveAmountValue, setReceiveAmountValue] = useState("");
  const [paymentRefNoValue, setPaymentRefNoValue] = useState("");
  const [balanceAmountValue, setBalanceAmountValue] = useState("");
  const [paymentMethodValue, setPaymentMethodValue] = useState("");
  const [lastPaymentMethod, setLastPaymentMethod] = useState("");
  const [paymentModeData, setPaymentModeData] = useState([]);
  const [isPayNowButtonPressed, setIsPayNowButtonPressed] = useState(false);
  const [storeCustomerAccountResponse, setStoreCustomerAccountResponse] =
    useState({});
  const [userAccountBalanceAmountError, setUserAccountBalanceAmountError] =
    useState("");

  const [modalText, setModalText] = useState("");
  const [modalStatus, setModalStatus] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);

  const isRoundOffMode = enabledAmountRoundOff === 0;

  const inputRegex = isRoundOffMode
    ? /^\d*$/
    : new RegExp(`^\\d*\\.?\\d{0,${enabledAmountRoundOff}}$`);


  const fetchLocalPaymentModeAPI = async () => {
    try {
      const response = await getViewPaymentModeV2(brandId);
      if (!response.data.error) {
        const Res = response.data?.paymentModes.filter(
          // (item) => item !== "ONLINE" && item !== "CASH" && item !== "COD"
          (item) => item !== "ONLINE"
        );
        setPaymentModeData(Res);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const fetchLocalPaymentMode = async () => {
    const { paymentMode } = getLocalPaymentMode();
    if (paymentMode && Object.keys(paymentMode).length > 0) {
      setPaymentModeData(paymentMode?.paymentModeList?.Location1);
    } else {
      setPaymentModeData([]);
    }
  };

  const fetchStoreCustomerAccount = () => {
    getStoreCustomerAccount(storeCustomerId, storeId)
      .then((response) => {
        if (!response.data.error) {
          const StoreCustomerAccountResponse = response.data;
          setStoreCustomerAccountResponse(StoreCustomerAccountResponse);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  let initialStartDate = new Date();
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  const [showStartDatePicker, setShowStartDatePicker] = useState(false);
  const toggleStartDatePicker = () => {
    setShowStartDatePicker(!showStartDatePicker);
  };

  // const balanceAmountCal = balanceAmount.toString();
  const balanceAmountNumber = Number(balanceAmount) || 0;
  const getReceiveAmountNumber = Number(selectedPaymentItemValue?.amount) || 0;
  const totalAmount = balanceAmountNumber + getReceiveAmountNumber;
  const balanceAmountCal = balanceAmount > 0 ? totalAmount : balanceAmountNumber;

  const calculateBalanceAmount = (receivedAmount) =>
    Number(
      (balanceAmountCal - (Number(receivedAmount) || 0)).toFixed(
        enabledAmountRoundOff
      )
    );

  useEffect(() => {
    if (userRole === "BY_STORE") {
      fetchLocalPaymentMode();
    } else {
      fetchLocalPaymentModeAPI();
    }
    fetchStoreCustomerAccount();
    const initialReceiveAmount =
      balanceAmount < 0
        ? getReceiveAmountNumber + balanceAmountNumber
        : getReceiveAmountNumber;
    setReceiveAmountValue(initialReceiveAmount.toString());
    setPaymentMethodValue(selectedPaymentItemValue?.paymentMode);
    setLastPaymentMethod(selectedPaymentItemValue?.paymentMode);
    setStartDate(new Date(selectedPaymentItemValue?.date));
    setPaymentRefNoValue(selectedPaymentItemValue?.paymentRefNo);
    setBalanceAmountValue(calculateBalanceAmount(initialReceiveAmount));
    // if (balanceAmount === 0 && paymentMethodValue === 'USER_ACCOUNT') {
    //   // setUserAccountBalanceAmountError(true);
    //   setIsPayNowButtonPressed(true);
    // } else {
    //   // setUserAccountBalanceAmountError(false);
    //   setIsPayNowButtonPressed(false);
    // }
  }, [selectedPaymentItemValue, balanceAmount]);

  // Function to reset the state variables
  const resetFields = () => {
    const initialReceiveAmount =
      balanceAmount < 0
        ? getReceiveAmountNumber + balanceAmountNumber
        : getReceiveAmountNumber;
    setReceiveAmountValue(initialReceiveAmount.toString());
    setPaymentRefNoValue(selectedPaymentItemValue?.paymentRefNo);
    setBalanceAmountValue(calculateBalanceAmount(initialReceiveAmount));
    setStartDate(new Date(selectedPaymentItemValue?.date));
    setPaymentMethodValue(selectedPaymentItemValue?.paymentMode);
    setPaymentError("");
    setReceiveAmountError("");
    setPaymentRefNoError("");
  };

  const handleStartDateChange = (selectedDate) => {
    if (selectedDate) {
      // const utcDate = new Date(
      //   Date.UTC(
      //     selectedDate.getFullYear(),
      //     selectedDate.getMonth(),
      //     selectedDate.getDate()
      //   )
      // );
      const currentTime = new Date();
      selectedDate.setHours(
        currentTime.getHours(),
        currentTime.getMinutes(),
        currentTime.getSeconds(),
        currentTime.getMilliseconds()
      );

      setStartDate(selectedDate);
    }
    setShowStartDatePicker(false);
  };

  // Initialize a state variable for storing pickup requests
  const [paymentError, setPaymentError] = useState("");
  const [receiveAmountError, setReceiveAmountError] = useState("");
  const [paymentRefNoError, setPaymentRefNoError] = useState("");

  const handleReceiveAmountChange = (text) => {
    // resetMethod();

    if (!isRoundOffMode && text === ".") {
      setReceiveAmountValue(".");
      return;
    }

    if (!inputRegex.test(text)) return;
    const receivedAmount = parseFloat(text);
    const finalValue = isRoundOffMode ? String(Math.round(receivedAmount)) : text;


    if (text !== "" && finalValue <= parseFloat(balanceAmountCal)) {
      setReceiveAmountValue(text);
      if (finalValue > 0) {
        setReceiveAmountError("");
        setUserAccountBalanceAmountError("");
        if (paymentMethodValue === "") {
          setPaymentError("Please select any Payment Method");
        } else {
          setPaymentError("");
        }
      } else if (finalValue === 0) {
        setReceiveAmountError("");
      } else {
        setReceiveAmountError("Please Enter Receive Amount");
      }
      updateBalanceAmount(finalValue, 0);
    } else {
      setReceiveAmountValue("");
      // setBalanceAmountValue(balanceAmountCal);s
      setBalanceAmountValue(calculateBalanceAmount(0));
      setPaymentError("");
      if (paymentMethodValue !== "") {
        setReceiveAmountError("Please Enter Receive Amount");
      }
    }
  };

  const handleReceiveAmountChangeAfterDone = (text) => {
    // resetMethod();

    if (!isRoundOffMode && text === ".") {
      setReceiveAmountValue(".");
      return;
    }

    if (!inputRegex.test(text)) return;
    const receivedAmount = parseFloat(text);
    const finalValue = isRoundOffMode ? String(Math.round(receivedAmount)) : text;


    if (text !== "" && finalValue <= parseFloat(grandTotal)) {
      setReceiveAmountValue(text);
      if (finalValue > 0) {
        setReceiveAmountError("");
        setUserAccountBalanceAmountError("");
        if (paymentMethodValue === "") {
          setPaymentError("Please select any Payment Method");
        } else {
          setPaymentError("");
        }
      } else if (finalValue === 0) {
        setReceiveAmountError("");
      } else {
        setReceiveAmountError("Please Enter Receive Amount");
      }
      updateBalanceAmount(finalValue, 0);
    } else {
      setReceiveAmountValue("");
      // setBalanceAmountValue(balanceAmountCal);s
      setBalanceAmountValue(calculateBalanceAmount(0));
      setPaymentError("");
      if (paymentMethodValue !== "") {
        setReceiveAmountError("Please Enter Receive Amount");
      }
    }
  };

  const handleBalanceAmountChange = (text) => {
    setBalanceAmountValue(text);
  };

  const handlePaymentRefNoValueChange = (text) => {
    setPaymentRefNoValue(text);
  };

  const handlePaymentMethodChange = (charge) => {
    setPaymentMethodValue(charge);
    setPaymentError("");
    setUserAccountBalanceAmountError("");
    let userAccountBalanceAmount = storeCustomerAccountResponse.advanceUnit;
    if (charge === "USER_ACCOUNT") {
      setReceiveAmountError("");
      if (enableUserAccountDeliveryDiscount) {
        if (balanceAmount >= 1) {
          if (userAccountBalanceAmount < balanceAmount) {
            setUserAccountBalanceAmountError("Your Account Balance is Low");
            handleReceiveAmountChange("");
          } else {
            handleReceiveAmountChange(balanceAmountCal);
            setReceiveAmountValue(balanceAmountCal);
          }
        }
      } else {
        setUserAccountBalanceAmountError("");
      }
    } else if (receiveAmountValue === "" || 0) {
      setReceiveAmountError("Please Enter Receive Amount");
      setUserAccountBalanceAmountError("");
    }
  };

  const updateBalanceAmount = (receivedAmount, discount) => {
    const calculatedBalance = Number(
      (balanceAmountCal - Number(receivedAmount) - Number(discount)).toFixed(
        enabledAmountRoundOff
      )
    );
    setBalanceAmountValue(calculatedBalance);
  };

  const handleCollectPaymentEdit = () => {
    if (paymentMethodValue === "") {
      setPaymentError("Please select any Payment Method");
    } else if (receiveAmountValue === "") {
      setReceiveAmountError("Please Enter Receive Amount");
    } else if (paymentRefNoValue === "") {
      setPaymentRefNoError("Please Enter Payment Reference No");
    } else {
      setPaymentError("");
      setReceiveAmountError("");
      setPaymentRefNoError("");
      let userAccountBalanceAmount = storeCustomerAccountResponse.advanceUnit;
      if (
        lastPaymentMethod !== paymentMethodValue &&
        paymentMethodValue === "USER_ACCOUNT" &&
        userAccountBalanceAmount < receiveAmountValue
      ) {
        setUserAccountBalanceAmountError("Your Account Balance is Low");
        setIsPayNowButtonPressed(false);
      } else {
        // const sendLocalDateTimeAsUTC = () => {
        //   const now = startDate;
        //   const offset = now.getTimezoneOffset(); // Offset in minutes
        //   const adjustedDate = new Date(now.getTime() - (offset * 60 * 1000) + 1000);
        //   return adjustedDate.toISOString(); // Local time in UTC format
        // };

        // Usage
        // const currentDateTime = sendLocalDateTimeAsUTC();

        const newDate = new Date(startDate);
        // newDate.setSeconds(newDate.getSeconds() + 1);
        const currentDateTime = newDate.toISOString();

        if (!isPayNowButtonPressed) {
          // Set the state to indicate that the button has been pressed
          setIsPayNowButtonPressed(true);

          const submitData = {
            id: selectedPaymentItemValue.id,
            date: currentDateTime,
            receivedBy: storeUserId,
            paidBy: storeCustomerId,
            paymentRefNo: paymentRefNoValue,
            amount: receiveAmountValue,
            paymentMode: paymentMethodValue,
          };

          updateOrderPayment(
            storeCustomerId,
            storeId,
            bookingOrderId,
            submitData
          )
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                const message = Res.message;
                const status = Res.status;

                // sendResponse({message, status, modalFun: false});
                // Reset state variables
                if (status === true) {
                  setModalVisible(true);
                  setModalStatus("success");
                  setModalText(message);
                } else {
                  setModalVisible(true);
                  setModalStatus("not Success");
                  setModalText(message);
                }
                setCollectPaymentEditModalVisible(false);
                sendDataToCollectPaymentUpdateModal({
                  success: true,
                });
                setIsPayNowButtonPressed(false);
                resetFields();
              }
            })
            .catch((err) => {
              console.error("Error:", err);
              setCollectPaymentEditModalVisible(false);
              sendDataToCollectPaymentUpdateModal({
                success: true,
              });
              setIsPayNowButtonPressed(false);
              resetFields();
            });
        }
      }
    }
  };

  const handleModalClose = () => {
    setCollectPaymentEditModalVisible(false);
    setIsPayNowButtonPressed(false);
    resetFields()
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={collectPaymentEditModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!collectPaymentEditModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div>
                <img
                  src={"Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif"}
                  style={{
                    width: 40,
                    height: 40,
                  }}
                />
              </div>

              <p className=" text-4xl text-primary-50 font-semibold uppercase">
                Collect Payment
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            {storeCustomerAccountResponse.advanceUnit > 0 && <div>
              <p
                className="text-3xl font-medium mx-4"
                style={{ color: "green" }}
              >
                Available Wallet Balance : {storeLocalData?.currencySymbol}{" "}
                {Number(storeCustomerAccountResponse.advanceUnit?.toFixed(enabledAmountRoundOff))}
              </p>
            </div>}
            <div
              className="flex-1  mx-4"
              style={{
                pointerEvents:
                  paymentMethodValue === "USER_ACCOUNT" &&
                    customerOrdersData.subscriptionDiscount > 0
                    ? "none"
                    : "auto",
              }}
            >
              <div
                className="border-round-xl shadow-2"
                style={{
                  backgroundColor: "#fff",
                }}
              >
                <Dropdown
                  value={paymentMethodValue}
                  onChange={(e) => {
                    setPaymentMethodValue(e.value);
                  }}
                  options={paymentModeData}
                  optionLabel="name"
                  placeholder="Payment Method"
                  className="w-full"
                />
              </div>
              <div>
                {paymentError !== "" && (
                  <p className="text-xl font-normal" style={{ color: "red" }}>
                    {paymentError}
                  </p>
                )}
              </div>
            </div>
            <div className="flex justify-content-between align-items-center mx-4">
              <p className=" text-xl font-medium capitalize">Date</p>
              <Calendar
                id="buttondisplay"
                value={startDate}
                minDate={
                  !enabledBackDate && userRole === "BY_STORE"
                    ? new Date()
                    : new Date(displayDate)
                }
                maxDate={new Date()}
                onChange={(e) => handleStartDateChange(e.value)}
                showIcon
                className="w-auto"
                dateFormat="dd/mm/yy"
              />
            </div>

            {balanceAmount > 0 ? (
              <div className="flex-1 mx-4">
                <div
                  className="border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                >
                  <InputText
                    placeholder="Receive Amount"
                    value={receiveAmountValue}
                    maxLength={50}
                    onChange={(e) => handleReceiveAmountChange(e.target.value)}
                    className="w-full bg-white-alpha-20 border-round-lg px-3 text-md "
                    keyFilter={isRoundOffMode ? "int" : /[\d.]/}
                    editable={
                      paymentMethodValue === "USER_ACCOUNT"
                        ? enableUserAccountDeliveryDiscount
                          ? true
                          : false
                        : true
                    }
                  ></InputText>
                  {receiveAmountError !== "" && (
                    <p className="text-xl font-normal" style={{ color: "red" }}>
                      {receiveAmountError}
                    </p>
                  )}
                </div>
              </div>
            ) : (
              <div className="flex-1 mx-4">
                <div
                  className="border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                >
                  <InputText
                    placeholder="Receive Amount"
                    value={receiveAmountValue}
                    maxLength={50}
                    onChange={(e) => userRole !== "BY_STORE" && handleReceiveAmountChangeAfterDone(e.target.value)}
                    className="w-full bg-white-alpha-20 border-round-lg px-3 text-md "
                    keyFilter={isRoundOffMode ? "int" : /[\d.]/}
                    editable={
                      paymentMethodValue === "USER_ACCOUNT"
                        ? enableUserAccountDeliveryDiscount
                          ? true
                          : false
                        : true
                    }
                  ></InputText>
                  {receiveAmountError !== "" && (
                    <p className="text-xl font-normal" style={{ color: "red" }}>
                      {receiveAmountError}
                    </p>
                  )}
                </div>
              </div>
            )}
            <div className="flex-1 mx-4">
              <div
                className="border-round-xl shadow-2"
                style={{
                  backgroundColor: "#fff",
                }}
              >
                <InputText
                  placeholder="Payment Reference No."
                  value={paymentRefNoValue}
                  maxLength={50}
                  onChange={(e) =>
                    handlePaymentRefNoValueChange(e.target.value)
                  }
                  className="w-full bg-white-alpha-20 border-round-lg px-3 text-md "
                ></InputText>
              </div>
              {paymentRefNoError !== "" && (
                <p className="text-xl font-normal" style={{ color: "red" }}>
                  {paymentRefNoError}
                </p>
              )}
            </div>
            {balanceAmount > 0 && (
              <div className="flex-1 mx-4">
                <div
                  className="border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                >
                  <InputText
                    placeholder="Balance Amount"
                    value={balanceAmountValue}
                    maxLength={50}
                    disabled={true}
                    // onChange={(e) => handleBalanceAmountChange(e.target.value)}
                    className="w-full bg-white-alpha-20 border-round-lg px-3 text-md "
                  ></InputText>
                </div>
              </div>
            )}

            {receiveAmountValue >= 0 ? (
              <Button
                disabled={
                  userAccountBalanceAmountError ? true : isPayNowButtonPressed
                }
                onClick={handleCollectPaymentEdit}
                className="mt-1 mb-3 mx-4 border-round-xl "
              >
                <p className=" w-full text-2xl  font-semibold flex justify-content-center">
                  Pay Now
                </p>
              </Button>
            ) : (
              <div className="flex align-items-center gap-2">
                <p className="text-xl font-normal" style={{ color: "red" }}>
                  Payment Can Not Be Edit Because Receive Amount Is Less Then
                  Zero.
                </p>
              </div>
            )}
          </div>
        )}
      ></Dialog>
      <SuccessModal
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default CollectPaymentEdit;
